var _path, _path2, _rect, _rect2, _circle, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h45v45H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAFF",
    d: "M-1085-510H835V570h-1920z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -371,
    y: -360,
    width: 493,
    height: 780,
    rx: 26.182,
    fill: "#ECF2FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -314,
    y: -23,
    width: 379,
    height: 92,
    rx: 12,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#ECF2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 31,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M7 4h31v31H7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 29.833c-1.076 0-1.991-.377-2.745-1.13-.753-.753-1.13-1.668-1.13-2.745 0-1.076.377-1.991 1.13-2.745.754-.753 1.669-1.13 2.745-1.13s1.991.377 2.745 1.13c.753.754 1.13 1.669 1.13 2.745 0 1.077-.377 1.992-1.13 2.745-.754.753-1.669 1.13-2.745 1.13Zm15.5 0c-1.076 0-1.991-.377-2.745-1.13-.753-.753-1.13-1.668-1.13-2.745 0-1.076.377-1.991 1.13-2.745.754-.753 1.669-1.13 2.745-1.13s1.991.377 2.745 1.13c.753.754 1.13 1.669 1.13 2.745 0 1.077-.377 1.992-1.13 2.745-.754.753-1.669 1.13-2.745 1.13ZM22.5 16.917c-1.076 0-1.991-.377-2.745-1.13-.753-.754-1.13-1.67-1.13-2.746s.377-1.99 1.13-2.744c.754-.754 1.669-1.13 2.745-1.13s1.991.376 2.745 1.13c.753.753 1.13 1.668 1.13 2.744 0 1.077-.377 1.992-1.13 2.745-.754.754-1.669 1.13-2.745 1.13Z",
    fill: "#006CC9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -401,
    y: -387,
    width: 553,
    height: 840,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_124_557",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -344,
    y: -50,
    width: 439,
    height: 152,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_124_557",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateAccountIcon);
export default __webpack_public_path__ + "static/media/corporate_account_icon.2adb899a580e489ad1587029216b80c4.svg";
export { ForwardRef as ReactComponent };